import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { showModal } from '../../reducers/modal'

import EmailCollection from './EmailCollection'

import { emailCollectionConfigs } from '../../config/email'

class NewsletterCollection extends Component {
  constructor () {
    super()
    this._afterSubmit = this._afterSubmit.bind(this)
  }
  render () {
    const { label, autoFocus, trackingContext } = this.props
    let trackingLabel = 'newsletterSignup'
    if (trackingContext) {
      trackingLabel += `-${trackingContext}`
    }
    return (
      <EmailCollection
        label={label}
        autoFocus={autoFocus}
        collectionConfig={emailCollectionConfigs.newsletter}
        afterSubmit={this._afterSubmit}
        trackingLabel={trackingLabel}
      />
    )
  }
  _afterSubmit (email) {
    const { afterSubmit, showModal } = this.props
    if (typeof afterSubmit === 'function') {
      afterSubmit(email)
    }

    // show thanks modal
    showModal(
      <div>
        <h1 className='h2 mb2'>You’re awesome!</h1>
        <p className='text-para'>
          We’ll send our newsletter about the future of ai, tech and Snips to:
          <br />
          <br />
          <code>{email}</code>
        </p>
      </div>
    )
  }
}

NewsletterCollection.propTypes = {
  label: PropTypes.string.isRequired,
  autoFocus: PropTypes.bool,
  showModal: PropTypes.func.isRequired,
  afterSubmit: PropTypes.func,
  trackingContext: PropTypes.string
}

NewsletterCollection.defaultProps = {
  label:
    'Subscribe to hear about our latest products, releases, events, and news.'
}

export default connect(null, { showModal })(NewsletterCollection)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/NewsletterCollection.js